import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { explode, getCookie, supportsCookies } from "../utils";

/**
 * Get current user decision from the cookie value in a minimal form.
 */
function getUserDecision(cookieName) {
  var cookieValue = getCookie(cookieName);

  if (!cookieValue) {
    if (!supportsCookies()) {
      // Use our `window` object instead of cookie value
      return window.rcbDisabledCookieComp || false;
    }

    return false;
  } // Validate cookie length


  var split = explode(cookieValue, ":", 3);

  if (split.length !== 3) {
    return false;
  }

  var _split = _slicedToArray(split, 2),
      uuidString = _split[0],
      revision = _split[1];

  var uuids = uuidString.split(",");
  var uuid = uuids.shift();
  var consent = JSON.parse(split[2]);
  return {
    uuid: uuid,
    previousUuids: uuids,
    revision: revision,
    consent: consent
  };
}

export { getUserDecision };